import React from 'react';
import Overlay from '../../partials/white_overlay';

const Standings = () => {
    return (
        <div style={{ position: 'relative' }}>
            <Overlay />
            <div className="p-4 hind" style={{ mixBlendMode: 'screen' }}>
                <h2 className="hind">Standings</h2>
                <p>Games in Qualifying Play will be scored according to the following: 3 points for a win, 1 point for a time and 0 points for a loss.</p>
                <p>Tiebreakers – after Qualifying Play – Ties in standings between two teams will be broken by; 1) head to head results between tied teams; 2) goal difference in qualifying play, 3) most goals scored in qualifying play, 4) least goals allowed, 5) if head coaches agree, a coin toss, if not, a shootout. Ties between three or more teams will be broken by; 1) goal difference in qualifying play, 2) most goals scored in qualifying play, 3) least goals allowed, 4) shootout with 1 team receiving a first-round bye by random draw. If the criteria for 3 or more teams eliminates all but 2 teams, the criteria for a tie between two teams (above) will be used to determine the rank of the two teams. A forfeit will be entered as score of 6-0.</p>
            </div>
        </div>
    );
}

export default Standings;



// WEBPACK FOOTER //
// ./src/components/rules/partials/standings.js